import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';

export const BorderedTabs = styled(Tabs, {
  shouldForwardProp: prop => prop !== 'dense',
})<{ dense?: boolean }>(({ theme, dense }) => {
  const height = dense ? 44 : 48;

  return {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    minHeight: height,
    '& .MuiTab-root': {
      minHeight: height,
      fontWeight: theme.typography.fontWeightSemiBold,
      ...(dense && {
        textTransform: 'none',
        flex: '1 1 0',
        minWidth: 'fit-content',
      }),
    },
  };
});
